const manageSchedule = {
  manageSchedule: {
    pageTitle: 'Manage Schedule',
    description: 'Check and manage all registered schedules.',
    tabs: {
      reservedSchedule: 'Reserved Schedule',
      duplicateBuffer: 'Duplicate Buffer'
    },
    filters: {
      groundStation: 'Ground Station',
      dateRange: 'Date Range',
      search: 'Search'
    },
    buttons: {
      search: 'Search',
      reset: 'Reset',
      cancel: 'Cancel',
      close: 'Close',
      delete: 'Delete',
      create: 'Create',
      update: 'Update'
    },
    buffer: {
      title: 'Setting Duplicate Buffer',
      scheduled: 'Scheduled',
      label: 'Duplicate Buffer (min)',
      tooltip: 'This sets the minimum interval (in minutes) between reservations, creating a buffer before and after the set time.',
      placeholder: 'e.g., 5',
      loading: 'Loading...',
      currentBuffer: 'Current Buffer',
      minutesUnit: 'min',
      updatedAt: 'Updated at: {{time}}',
      noBuffer: 'No buffer is currently set.',
    },
    modals: {
      deleteBufferTitle: 'Delete Buffer',
      deleteBufferBody: 'Are you sure you want to delete the buffer setting?\nThis operation cannot be undone.',
      cancelScheduleTitle: 'Cancel Schedule',
      cancelScheduleBody: 'Are you sure you want to cancel your schedule?\nThis operation cannot be undone.'
    },
    alerts: {
      statusUpdateFailed: 'Failed to update status. Please try again.',
      cannotCancel: 'This schedule cannot be canceled.',
      cancelFailed: 'Failed to cancel. Please try again.',
      bufferRequired: 'Please enter a value for Buffer minutes.',
      bufferPositive: 'Please enter a value greater than or equal to 0.',
      noOrderId: 'orderId does not exist. Please try again.'
    }
  }
};

export default manageSchedule;